<div class="modal-header">
    <div class="row w-100">
        <div class="col-md-11">
            <h5 class="modal-title">Send Files</h5>
        </div>
        <div class="col-md-1 pe-0">
            <button type="button" class="close float-end text-white pe-0" aria-label="Close"
                data-testid="modals.send-files.close-btn"
                (click)="activeModal.dismiss()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="font-18 pb-2">Please attach your files to this message and provide a description of them. Please select who should receive an email with the files attached.</div>
    <form [formGroup]="sendFilesForm" novalidate>
        <div class="pb-4">
            <select class="form-control" [(ngModel)]="contact_advisor" formControlName="contactAdvisor"
                aria-label="Select recipient"
                data-testid="modals.send-files.recipient-select">
                <option value='' selected>Select Recipient</option>
                <option *ngFor="let option of advisoryTeam" value="{{option.id}}">{{option.name}} -
                    {{option.user_type}} </option>
            </select>
        </div>
        <div class="pb-4">
            <input type="text" #filesubject class="form-control" placeholder="Subject" [(ngModel)]="files_subject"
                formControlName="filesSubject" autofocus="true"
                aria-label="Subject"
                data-testid="modals.send-files.subject-input">
            <div *ngIf="sendFilesFormSubmitted" class="text-danger pt-1" role="alert">
                <div *ngIf="formControl.filesSubject.errors?.required">Subject is mandatory.</div>
            </div>
        </div>
        <div class="pb-4">
            <textarea class="form-control" placeholder="Type your Message here" rows="6" columns="12"
                [(ngModel)]="files_message" formControlName="filesMessage"
                aria-label="Message"
                data-testid="modals.send-files.message-textarea"></textarea>
            <div *ngIf="sendFilesFormSubmitted" class="text-danger pt-1" role="alert">
                <div *ngIf="formControl.filesMessage.errors?.required">Message is mandatory.</div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12 col-sm-12">
                <div class="upload-file-drop-zone" appDropfile (fileDropped)="onFileDropped($event)">
                    <div class="text-center mt-4 text-secondary pt-2" *ngIf="files.length==0">Drop Files</div>
                    <div *ngFor="let file of files ; let i = index" class="float-start">
                        <div class="filesList text-dark p-2">
                            <span>{{file.name}}</span>
                            <i class="fa fa-times crossIcon ps-1 cursor-pointer text-danger" aria-hidden="true"
                                [attr.data-testid]="'modals.send-files.remove-file-btn-' + i"
                                role="button" tabindex="0" [attr.aria-label]="'Remove file ' + file.name"
                                (click)="removeFiles(i)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12 col-sm-12 no-padding-left-right">
                <div class="float-start me-2 font-14 text-secondary"><label>Attach Files</label></div>
                <label class="float-start padding paperClip" aria-label="Attach files">
                    <input type="file" class="d-none" ng-model="uploadFile" id="fileUpload" name="uploadFile"
                        multiple="multiple" (change)="getFileDetails($event)"
                        aria-label="Choose files to attach"
                        data-testid="modals.send-files.file-input" />
                    <i class="fa fa-paperclip font-14 color-brown cursor-pointer" aria-hidden="true"></i>
                </label>
            </div>
            <div *ngIf="sendFilesFormSubmitted && showError" class="text-danger ms-3 pt-1">Please attach a file.</div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-link" data-testid="modals.send-files.cancel-btn" (click)="closeModal()" [disabled]="disableBtn">
        CANCEL
    </button>
    <button type="button" class="btn btn-primary btn-sm rounded-pill" data-testid="modals.send-files.send-btn" (click)="saveFiles(this)" [formvalid]="sendFilesForm.valid" appButtonDisable>
        Send Files
    </button>
</div>
